import { DistributionStatus } from '../../TargetingShared/enum/distribution-status.enum';

export enum TargetingEventsEnum {
    LIST_CREATED = 'LIST_CREATED',
    LIST_DELETED = 'LIST_DELETED',
    LIST_MODIFIED = 'LIST_MODIFIED',
    CONTACTS_ADDED_TO_LIST = 'CONTACTS_ADDED_TO_LIST',
    CONTACTS_REMOVED_FROM_LIST = 'CONTACTS_REMOVED_FROM_LIST',
    SAVED_SEARCH_CREATED = 'SAVED_SEARCH_CREATED',
    SAVED_SEARCH_DELETED = 'SAVED_SEARCH_DELETED',
    SAVED_SEARCH_MODIFIED = 'SAVED_SEARCH_MODIFIED',
}

export const userEventToIconMap: Map<TargetingEventsEnum | DistributionStatus, string> = new Map<TargetingEventsEnum | DistributionStatus, string>([
    [TargetingEventsEnum.LIST_CREATED, 'agpr-i-list-created'],
    [TargetingEventsEnum.LIST_DELETED, 'agpr-i-list-deleted'],
    [TargetingEventsEnum.LIST_MODIFIED, 'fa-kit fa-agpr-list-modified'],
    [TargetingEventsEnum.CONTACTS_ADDED_TO_LIST, 'agpr-i-contact-added'],
    [TargetingEventsEnum.CONTACTS_REMOVED_FROM_LIST, 'agpr-i-contact-deleted'],
    [TargetingEventsEnum.SAVED_SEARCH_CREATED, 'agpr-i-search-created'],
    [TargetingEventsEnum.SAVED_SEARCH_DELETED, 'agpr-i-search-deleted'],
    [TargetingEventsEnum.SAVED_SEARCH_MODIFIED, 'agpr-i-search-modified'],
    [DistributionStatus.draft, 'agpr-i-draft'],
    [DistributionStatus.failed, 'agpr-i-failed'],
    [DistributionStatus.scheduled, 'agpr-i-scheduled'],
    [DistributionStatus.sent, 'agpr-i-sent'],
    [DistributionStatus.pending, 'agpr-i-pending'],
]);

export enum UserEventTypesEnum {
    LIST = 'LIST',
    DISTRIBUTION = 'DISTRIBUTION',
    SAVED_SEARCH = 'SAVED_SEARCH',
}

export enum AlertSurgeMetricEventsEnum {
    MENTION_VOLUME = 'MENTION_VOLUME',
    IMPRESSIONS = 'IMPRESSIONS',
    SENTIMENT = 'SENTIMENT'
}
